import { ILoadingCellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
@Component({
  selector: 'app-loading',
  standalone: false,
  templateUrl: './loading.component.html',
})
export class LoadingComponent implements ILoadingCellRendererAngularComp {
  agInit(): void {}
}
